export const carteraTitles = {
    managements:{
        informacionGeneral:{
            id_cliente: 'Cuenta Bis',
            rfc:'RFC',
            gerencia:'Reloj',
            id_grupo: 'Servicio Terceros',
            nombre_grupo: 'Estatus Fecha Pago',
            producto: 'Desc Plan',
            rmd: 'Email',
            territorio: 'Región',
            zona: 'Tipo Asignación',
            despacho: 'Fecha Fin'
        },
        pago:{
            id_cliente:'Cuenta Bis',
            producto: 'Desc Plan',
            atraso_max:'Bucket',
            saldo:'Saldo Serv',
            total:'Saldo Serv Total',
            fecha_pago_ultimo:'Fecha Ultimo Pago',
            importe_pago_ultimo:'Estatus Monto Pago',
            campania: 'Opción Descuento',
            fecha_asignacion:'Fecha Asignacion',
            dias_asignacion:'Fecha Fin'
        },
        direccion:{
            id_cliente:'Cuenta Bis',
            direccion:'Calle',
            num_ext:'Num Ext.',
            codigoPostal:'CP',
            colonia:'Colonia',
            poblacion:'Municipio',
            estado:'Estado'
        },
        telefonos:{
            id_cliente:'Cuenta Bis',
            telefono1:'Telefono',
            telefono2:'Contacto 1',
            telefono3:'Contacto 2'
        }
    },
    bitacora:{

    },
    calendar:{

    },
    carruselNoticias:{
        
    },
   database:{

    },
    documents:{

    },
    graficasEstaticas:{

    },
    grupos:{

    },    
    minutas:{

    },
    notices:{

    },
    projectTracking:{

    },
    reports:{

    },
    userManagement:{

    },
    workplaces:{
        
    }
}